import { combineReducers } from '@reduxjs/toolkit';
import { createReducer } from 'typesafe-actions';

import {
    AgeGroupEntity,
    CountryLocationSdi,
    DataProject,
    Dataset,
    Organization,
    ResourceCategory,
    SmartOptionResource,
} from '@portal/common/types';
import { getNamesById } from '@portal/common/utility/get-names-by-id';

import {
    addSmartOption,
    getAgeGroupsAsync,
    getAllSmartOptionsAsync,
    getCategoriesAsync,
    getCountryLocationsSdi,
    getDataCollectionsAsync,
    getDataProjectsAsync,
    getDatasetsAsync,
    getOrganizationsAsync,
    removeSmartOption,
    requiredDataLoaded,
} from './actions';

type State = {
    categories: ResourceCategory[] | null;
    organizations: Organization[] | null;
    dataCollectionNamesById: Record<number, string>;
    datasets: Dataset[] | null;
    dataProjects: DataProject[] | null;
    ageGroups: null | AgeGroupEntity[];
    countryLocationSdi: null | CountryLocationSdi[];
    smartOptions: null | SmartOptionResource[];
    isRequiredDataLoaded: boolean;
};

const initialState: State = {
    categories: null,
    organizations: null,
    dataCollectionNamesById: {},
    datasets: null,
    dataProjects: null,
    ageGroups: null,
    countryLocationSdi: null,
    smartOptions: null,
    isRequiredDataLoaded: false,
};

export default combineReducers<State>({
    categories: createReducer(initialState.categories).handleAction(
        getCategoriesAsync.success,
        (state, action) => action.payload
    ),
    organizations: createReducer(initialState.organizations).handleAction(
        getOrganizationsAsync.success,
        (state, action) => action.payload
    ),
    dataCollectionNamesById: createReducer(initialState.dataCollectionNamesById).handleAction(
        getDataCollectionsAsync.success,
        (state, action) => getNamesById(action.payload)
    ),
    datasets: createReducer(initialState.datasets).handleAction(
        getDatasetsAsync.success,
        (state, action) => action.payload
    ),
    dataProjects: createReducer(initialState.dataProjects).handleAction(
        getDataProjectsAsync.success,
        (state, action) => action.payload
    ),
    isRequiredDataLoaded: createReducer(initialState.isRequiredDataLoaded).handleAction(
        requiredDataLoaded,
        () => true
    ),
    ageGroups: createReducer(initialState.ageGroups).handleAction(
        getAgeGroupsAsync.success,
        (state, action) => action.payload
    ),
    countryLocationSdi: createReducer(initialState.countryLocationSdi).handleAction(
        getCountryLocationsSdi.success,
        (state, action) => action.payload
    ),
    smartOptions: createReducer(initialState.smartOptions)
        .handleAction(getAllSmartOptionsAsync.success, (state, action) => action.payload)
        .handleAction(addSmartOption, (state, action) => [...state, action.payload])
        .handleAction(removeSmartOption, (state, action) =>
            (state || []).filter((el) => el.id !== action.payload)
        ),
});
